import { Line } from '../../../Common/Charts/Line';
import { monthsIndexesWithou0 } from '../../../Common/Util/getMonthsByYear';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const MonthlyEvolutionRelationIndividualAndhouseHold = () => {
    const { chartData } = useResultsChartsDataContext();

    return (
        <Line
            title={
                'Evolução mensal da relação entre cadastros individuais por cadastros domiciliares e territoprial'
            }
            subtitles={chartData?.monthlyEvolutionRelationIndividualAndhouseHold?.map(
                (item) => monthsIndexesWithou0[item.description]
            )}
            values={chartData?.monthlyEvolutionRelationIndividualAndhouseHold?.map(
                (item) => item.total || 0
            )}
            category="Estatisticas Vitais"
        />
    );
};
